import React from 'react';
import './error-sec.css'
import Cta from '../components/common/cta';
import pic36 from '../assets/pic36.png'
import { useEffect } from 'react';
import { useRef } from 'react';
import { supabase } from '../supabase';
import { useState } from 'react';

const Errorsec = ({ loading }) => {

const headerRef = useRef(null);

  useEffect(() => {
    if (loading) return;

    const el = headerRef.current;
    if (!el) return;


    el.classList.remove("in-view");
    void el.offsetHeight;
    el.classList.add("in-view");

  }, [loading]);



    const [Errorpage, setErrorpage]= useState([]);

        useEffect(() => {
        const getErrorpage = async()=>{
            const res = await supabase.from('error_page_mobile').select('*').order('id', { ascending: true });;
        setErrorpage(res.data);
        }
        getErrorpage();
        }, []);







    return ( 
        <section className='sec1-error'>
            <section className='sec1-sub-errorr'>
                <article className='container-header'  ref={headerRef}>
                    <h1 className='error-header'>{Errorpage?.[1]?.header}</h1>
                                        <img className='img-error' src={pic36} alt='light pic'></img>
                </article>
                    <h3 className='sectence-header'>{Errorpage?.[1]?.para}</h3>
                    <button className='cta-cont-error' >
                    <Cta title={Errorpage?.[1]?.cta} to="/"  />
                    </button>





            </section>
        </section>
     );
}
 
export default Errorsec;